import { Carousel, Flex, Grid, Typography } from 'antd';
import './index.scss';
import { CarouselProps } from 'antd/lib';
import { createRef, FC, useRef } from 'react';
import { CarouselRef } from 'antd/es/carousel';
import { ArrowButton } from '../carousel-arrow';
import { PromotionSimplified } from '@/types';
import { useQuery } from '@tanstack/react-query';
import { getAllPromotions } from '@/api/promotions';

interface PropmotionItem {
  title: string;
  gradient: string;
  description: string;
}

interface Props {
  promotions: PromotionSimplified[];
  isLoading: boolean;
  showDefaultArrows?: boolean;
  carouselConfig?: CarouselProps;
}

export const promotionsCarouselRef = createRef<CarouselRef>();

export const PopularPromotions: FC<Props> = ({
  showDefaultArrows = true,
  carouselConfig,
  promotions,
}) => {
  const { lg } = Grid.useBreakpoint();

  const gradientPalette = [
    'linear-gradient(109deg, #F6C38B -0.54%, #95C4B4 38.8%)',
    'linear-gradient(109deg,rgb(246, 139, 244) -0.54%,rgb(157, 149, 196) 38.8%)',
    'linear-gradient(109deg,rgb(139, 246, 180) -0.54%,rgb(196, 149, 174) 38.8%)',
  ];

  const config: CarouselProps = {
    dots: false,
    centerMode: true,
    className: 'carousel',
    ...carouselConfig,
  };

  if (!promotions) return;

  return (
    <div className={'popular-promotions'}>
      <Carousel ref={promotionsCarouselRef} {...config}>
        {promotions.map((item, index) => (
          <div key={item.key}>
            <Flex
              vertical
              gap={12}
              justify={'flex-start'}
              className={'promotion-card'}
              style={{ background: gradientPalette[index % 3] }}
            >
              <Typography.Text className={'card-title'}>
                {item.title}
              </Typography.Text>

              <Typography.Text className={'card-description'}>
                {item.description}
              </Typography.Text>
            </Flex>
          </div>
        ))}
      </Carousel>

      {showDefaultArrows && (
        <Flex gap={16} justify={'center'} style={{ marginTop: '16px' }}>
          <ArrowButton ref={promotionsCarouselRef} type={'next'} />
          <ArrowButton ref={promotionsCarouselRef} type={'prev'} />
        </Flex>
      )}
    </div>
  );
};
